<template>
  <WebhookForm :id="id" :initial="effectiveInitial" :visibility-config="visibilityConfig" @saved="$emit('saved')">
    <template #parameters="{ getSecret, setSecret }">
      <div class="box">
        <h2 class="subtitle">{{ $t('datadog.settings') }}</h2>

        <BFieldHint :label="$t('datadog.apiKey')" hintKey="">
          <b-select :model-value="getSecret('DATADOG_API_KEY')"
                    :placeholder="$t('datadog.selectSecret')"
                    @update:model-value="val => setSecret('DATADOG_API_KEY', String(val))">
            <option v-for="name in secretOptions" :key="name" :value="name">{{ name }}</option>
          </b-select>
        </BFieldHint>
      </div>
    </template>
  </WebhookForm>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import WebhookForm from '@/views/templates/WebhookForm.vue'
import BFieldHint from '@/components/BFieldHint.vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'DatadogForm',
  components: { WebhookForm, BFieldHint },
  props: {
    id: String,
    initial: Object as PropType<Record<string, unknown>>
  },
  emits: ['saved'],
  setup(props) {
    const store = useStore()
    const secretOptions = computed<string[]>(() => {
      const s: any = store.state.secrets || []
      const list = Array.isArray(s) ? s : Object.values(s)
      return list.map((x: any) => String(x.name)).filter(Boolean)
    })

    const defaultInitial = {
      name: '',
      event: 'datadog-data',
      template: 'datadog',
      url: 'https://app.datadoghq.com/api/v2/series',
      requestType: 'POST',
      noDefaults: true,
      rejectUnauthorized: true,
      unchunked: false,
      data_url_response_event: false,
      headers: {
        'DD-API-KEY': '{{{DATADOG_API_KEY}}}'
      },
      json: {
        series: [
          {
            metric: 'particle.data',
            points: [
              {
                timestamp: '{{{time}}}',
                value: '{{{data}}}'
              }
            ],
            type: 'gauge'
          }
        ]
      }
    } as Record<string, unknown>

    const effectiveInitial = computed<Record<string, unknown>>(() => {
      return (props.initial as any) || defaultInitial
    })
    
    const visibilityConfig = {
      jsonTab: false,
      secrets: false,
      requestURL: false,
      requestType: false,
      requestFormat: false,
      queryParams: false,
      httpHeaders: false,
      httpBasicAuth: false,
      responseTemplate: false
    }
    
    return { secretOptions, effectiveInitial, visibilityConfig }
  }
})
</script>
